import BaseDocumentHead, { IDocumentHead } from 'components/DocumentHead'
import { inject } from 'mobx-react'
import * as R from 'ramda'
import React, { FC } from 'react'
import { translate } from 'react-i18next'
import { IStoreProvider } from 'store'
import TrackOutfitDetailPageView from './TrackOutfitDetailPageView'

const DocumentHead: FC<
  Partial<IDocumentHead> & { isOdpLoading: boolean }
> = props => (
  <>
    {!props.isOdpLoading && (
      <TrackOutfitDetailPageView pageTitle={props.title || ''} />
    )}
    <BaseDocumentHead {...props} />
  </>
)

export default R.compose(
  translate(),
  inject((store: IStoreProvider, props) => {
    const t = (props as any).t
    const odpStore = store.odpStore
    const hasDroppedSubDomain = store.tadaridaFeatureStore.hasDroppedSubDomain

    const outfit = store.odpStore.outfitId
      ? store.service.outfits.getById(store.odpStore.outfitId)
      : null

    const outfitName = outfit?.title
    const outfitGender = outfit?.gender
    const backendDescription = outfit?.description
    const builtTitle = t('{{outfitName}} online kaufen | ABOUT YOU', {
      outfitName,
    })
    const builtDescription = t(
      '{{outfitName}} versandkostenfrei bei ABOUT YOU bestellen. Große Outfit Auswahl {{forGender}} ✓Kostenlose Retoure ✓Zahlung auf Rechnung',
      {
        outfitName,
        forGender:
          outfitGender === 'female' ? t('für Frauen') : t('für Männer'),
      },
    )
    const hreflangs = odpStore.seo.hreflangs

    return {
      title: builtTitle,
      description: backendDescription || builtDescription,
      renderHreflangs: true,
      renderMobileAlternate: true,
      links: hreflangs,
      robots: 'index, follow',
      customTitleTemplate: true,
      hasDroppedSubDomain,
    }
  }),
)(DocumentHead)
